import { gql } from "@apollo/client";

const PLATFORM_SPONSORS = gql`
  query platformSponsors($filter: ListSponsorInput) {
    platformSponsors(filter: $filter) {
      id
      title
      image
      link
    }
  }
`;

export default PLATFORM_SPONSORS;
